import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";
import Link from "@/components/common/Link";

export default function ProjectsArea() {
  const { messages } = useI18n();
  const projects = messages.projects;
  const projectsItems = projects.items || [];
  const categories = Array.from(new Set(projectsItems.map((item: any) => item.categories)));

  return (
    <div className="project-section project-masonary">
      <div className="divider"></div>

      <div className="container">
        <div className="section-heading text-center mb-5">
          <span className="subtitle">{projects.subtitle}</span>
          <h2 className="mb-3">{projects.title}</h2>
          <p className="mb-0">{projects.description}</p>
        </div>

        {/* فئات المنتجات */}
        {categories.length > 0 && (
          <div className="d-flex flex-wrap gap-2 justify-content-center mb-4">
            {(categories as string[]).map((cat: string, index: number) => (
              <span key={index} className="badge badge-category px-3 py-2">
                {cat}
              </span>
            ))}
          </div>
        )}

        {/* بطاقات المنتجات */}
        <div className="row g-4">
          {projectsItems.map((item: any) => (
            <div key={item.id} className="col-12 col-md-6 col-xl-4">
              <div className="project-card h-100">
                <div className="position-relative">
                  <Image
                    src={item.image}
                    alt={item.title}
                    width={613}
                    height={400}
                    priority={item.id <= 2}
                    className="w-100 h-auto"
                    style={{ borderRadius: "12px" }}
                  />
                  <span className="badge badge-overlay position-absolute top-0 end-0 m-3">
                    {item.categories}
                  </span>
                </div>
                <div className="project-info p-3">
                  <h3 className="h5 mb-2">{item.title}</h3>
                  <p className="mb-0">{projects.productDescription}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="divider-sm"></div>

      <div className="text-center">
        <Link href="/contact" className="btn btn-primary">
          <span>
            {projects.requestConsultation} <i className="ti ti-arrow-up-right"></i>
          </span>
          <span>
            {projects.requestConsultation} <i className="ti ti-arrow-up-right"></i>
          </span>
        </Link>
      </div>

      <div className="divider"></div>
    </div>
  );
}